import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ledgerService from "../../services/ledgerService";

export const fetchLedgers=createAsyncThunk(
    "ledgers/fetch",
    async()=>{

        return await ledgerService.getPorts();

    }
);

export const removeLedger=createAsyncThunk(
    "ledgers/delete",
    async(id)=>{

        await ledgerService.deletePort(id);

        return id;

    }
);

export const addLedger = createAsyncThunk(
    "ledger/add",
    async (formData, thunkAPI) => {
        try {
            return await ledgerService.addLedger(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const ledgerSlice=createSlice({

    name:"ledgers",

    initialState:{
        ledgers:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchLedgers.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchLedgers.fulfilled,(state,action)=>{
    state.loading=false;
    state.ledgers=action.payload;
})

.addCase(fetchLedgers.rejected,(state)=>{
    state.loading=false;
})

.addCase(addLedger.fulfilled,(state,action)=>{

    state.ledgers.unshift(action.payload);

})

.addCase(removeLedger.fulfilled,(state,action)=>{

    state.ledgers=
    state.ledgers.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default ledgerSlice.reducer;